var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestkubeSymbolColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.484 15.67 18.45.588a2.005 2.005 0 0 0-2.827 0L.586 15.669c-.373.374-.584.88-.586 1.41v7.852c.002.53.213 1.036.586 1.41l15.036 15.08a2.004 2.004 0 0 0 2.827 0l15.035-15.08c.374-.374.585-.88.587-1.41V17.08a2.004 2.004 0 0 0-.587-1.41Zm-1.25 8.255L29.33 21.01l2.903-2.911v5.825Zm-4.158-4.172L17.923 9.567V2.576l13.638 13.68-3.485 3.497ZM7.25 21.009l9.786-9.816 9.787 9.816-9.787 9.818-9.786-9.818Zm8.899-18.433v6.99L5.994 19.754 2.51 16.255l13.639-13.68Zm.887 37.758v-6.992l11.041-11.074 3.485 3.505-14.526 14.561Z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 6.147,
    y1: 31.93,
    x2: 27.989,
    y2: 10.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9E9DD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#7A70CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#604FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#513AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B33C0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestkubeSymbolColor);
export default __webpack_public_path__ + "static/media/testkube-symbol-color.d0427607234ca9d510fb72719ce97bdc.svg";
export { ForwardRef as ReactComponent };